import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';
import { ShapeUrlAction } from '@tokamap/core';

export default async function linkUrlToShape(shapeIds: string | string[], urlAction: ShapeUrlAction) {
	const editor = currentEditorStore.get;
	const ids = Array.isArray(shapeIds) ? shapeIds : [shapeIds];
	const shapes = ids
		.map(id => editor.getAllShapes().find(s => s.id === id))
		.filter((s): s is NonNullable<typeof s> => s !== undefined);

	// Même logique que `linkPlaceToShape` (voir CLAUDE.md "Sélection multiple") : une seule entrée
	// d'historique/sauvegarde pour tout le groupe, seules les formes qui n'ont pas déjà `action:
	// 'open_url'` sont incluses.
	const idsNeedingAction = shapes.filter(s => s.action !== 'open_url').map(s => s.id);

	if (idsNeedingAction.length) {
		editor.setShapeAction(idsNeedingAction, 'open_url');
	}

	editor.setShapeUrlAction(ids, urlAction);
}
